const cc = console.log
function getFocusableElements(container, options) {
	const { ignoreClasses, ignoreAttributes } = {
		ignoreClasses: [],
		ignoreAttributes: [],
		...options
	}

	let focusables = Array.from(
		container.querySelectorAll(
			"summary, a[href]:not([tabindex='-1']), button:enabled:not([tabindex='-1']), [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	)

	focusables = focusables.filter(e => {
		const classIgnored = ignoreClasses.some(cl => e.classList.contains(cl))
		const displayed = e.offsetWidth > 0 && e.offsetHeight > 0
		return displayed && !classIgnored
	})

	return focusables
}

const trapFocusHandlers = {};
function trapFocus(container, options = {}) {
	removeTrapFocus()
	const { elementToFocus, externalTrigger } = {
		elementToFocus    : container,
		externalTrigger   : null,
		...options
	}

	var elements = getFocusableElements(container)
	var first = elements[0]
	var last = elements[elements.length - 1]
	trapFocusHandlers.focusin = (event) => {
		const dontPass = (
			event.target !== container &&
			event.target !== last &&
			event.target !== first &&
			(!externalTrigger || event.target !== externalTrigger)
		)
		if (!dontPass) document.addEventListener("keydown", trapFocusHandlers.keydown);
	}

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	}

	trapFocusHandlers.keydown = function (event) {
		if (!event.code || event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault()
			if (externalTrigger) externalTrigger.focus()
			else first.focus()
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ( (event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault();
			if (externalTrigger) externalTrigger.focus()
			else last.focus()
		}

		if (event.target === externalTrigger) {
			event.preventDefault()
			if (event.shiftKey) last.focus()
			else first.focus()
		}
	}

	document.addEventListener("focusout", trapFocusHandlers.focusout)
	document.addEventListener("focusin", trapFocusHandlers.focusin)
	elementToFocus?.focus();
}


function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);
	if (elementToFocus) elementToFocus.focus({ preventScroll: true });
}

function pauseAllMedia(container=document) {
	container.querySelectorAll("video-vimeo, video-youtube, video").forEach(video => {if(video.pause) video.pause()})
	container.querySelectorAll("product-model").forEach(model => model.modelViewerUI?.pause())
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input")
		this.changeEvent = new Event("change", { bubbles: true })
		this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onButtonClick.bind(this)))
	}
	onButtonClick(event) {
		event.preventDefault()
        const previousValue = this.input.value
        const target = event.target.matches('button') ? event.target : event.target.closest('button')
		target.name === "plus" ? this.input.stepUp() : this.input.stepDown()
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
	}

}


function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait)
	};
}

const serializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);
	for (const key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: { "Content-Type": "application/json",  'Accept': `application/${type}` }
	}
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this)
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}
			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};


class CartNote extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('input', debounce((event) => {
			const body = JSON.stringify({ note: event.target.value })
			fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
		}, 500))
	}
}


class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener('click', this.loadContent.bind(this));
	}

	loadContent() {
		window.pauseAllMedia();
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div');
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
			this.setAttribute('loaded', true);
			const media = content.querySelector('video, model-viewer, .video-element')
			this.appendChild(media).focus();
			const slider = this.closest('product-slider') || this.closest('modal-slider')

			if(slider) {
				slider.handleTouchMove()
				if(slider.resizeMedia) slider.resizeMedia(media)
			}
		}
	}
}

customElements.define('deferred-media', DeferredMedia)
customElements.define('cart-note', CartNote)
customElements.define("quantity-input", QuantityInput)

const links = document.links; 
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) { 
    if (links[i].hostname !== window.location.hostname) { 
      links[i].target = '_blank'; 
      links[i].rel = 'noreferrer noopener'; 
  } 
}